// src/utils/useIsMobile.js
//
// P1-6 (PROFIL_DERIN_ANALIZ_V2 §4.2) — Mobil/desktop breakpoint tekleştirme.
//
// Problem: App.js `width <= 768`, Profile.js `innerWidth <= 735` kullanıyordu.
// 736–768px aralığında (küçük tablet) App mobil kompozisyon kurarken Profile
// desktop bileşeni render ediyordu → tutarsız layout.
//
// Tek doğruluk kaynağı: MOBILE_BREAKPOINT. Proje kuralı gereği ayrım CSS
// @media ile değil JS ile yapılır (Feed.js / PostDetailModal / LocationChip
// aynı 768 eşiğini lokal kopyalarla kullanıyor; onlar davranış değiştirmeden
// ileride bu hook'a taşınabilir).

import { useEffect, useState } from "react";

export const MOBILE_BREAKPOINT = 768;

/**
 * Viewport genişliği eşiğin altında/eşit mi? Resize'da canlı güncellenir.
 *
 * @param {number} maxWidth Varsayılan MOBILE_BREAKPOINT (768).
 * @returns {boolean}
 */
export default function useIsMobile(maxWidth = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= maxWidth
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= maxWidth);
    window.addEventListener("resize", onResize);
    // Eşik parametresi değiştiyse mevcut genişlikle senkronla.
    onResize();
    return () => window.removeEventListener("resize", onResize);
  }, [maxWidth]);

  return isMobile;
}
